import store from '../store/index'; 

export function formatCurrency (value) {
  if (typeof value !== 'number') {
    return value;
  }
  var formatter = new Intl.NumberFormat(store.state.langCode, {
    style: 'currency',
    currency: store.state.currencyCode,
    minimumFractionDigits: 0
  });
  return formatter.format(value);
}
